export default class SelectImg {
    constructor() {
        //this.init()
    }

    init() {
        this.setCharaimg()
    }

    //ベストショット配置
    setCharaimg() {
        const selectchara = document.getElementById('selectchara')

        console.log(MAIN.data.character)

        selectchara.addEventListener('change', (event) => {
            MAIN.data.character = selectchara.value
            console.log(MAIN.data.character)

            this.setSelectPh()
        })
    }

    //ベストショット配置
    setSelectPh() {
        const chara = MAIN.data.character
        const slidenum = MAIN.data.bestimgnum

        const questionphlist = document.querySelector('.js-ques-ph')
        questionphlist.innerHTML = ''

        for (let i = 1; i <= slidenum; i++) {
            const questionitem = `<li class="generator__img__select__item c-hover_br_p js-select-img" data-img="${i}">
                <img src="/oshigatari/assets/img/generator/bg/${chara}/ph_${i}.png" alt="">
            </li>`
            questionphlist.insertAdjacentHTML('beforeend', questionitem)
        }

        this.getIngId()
    }

    //ベストショット選択
    getIngId() {
        const imgselectbtn = [...document.querySelectorAll('.js-select-img')]

        imgselectbtn.forEach((el) => {
            el.addEventListener('click', () => {
                imgselectbtn.forEach((e) => {
                    if (e.classList.contains('-active')) {
                        e.classList.remove('-active')
                    }
                })

                const imgid = el.getAttribute('data-img')
                MAIN.data.bestimgid = imgid

                el.classList.add('-active')

                MAIN.pagination.activeOkBtn()
            })
        })
    }

    //ベストショット選択リセット
    rsetSelectPh() {
        const imgselectbtn = [...document.querySelectorAll('.js-select-img')]

        imgselectbtn.forEach((e) => {
            if (e.classList.contains('-active')) {
                e.classList.remove('-active')
            }
        })
    }
}
